/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamExamitemidPreview200,
  GetApiV1ExamExamitemidPreview401,
  GetApiV1ExamExamitemidPreview404,
  GetApiV1ExamExamitemidPreview500,
  GetApiV1ExamExamitemidPreviewPathParams,
  GetApiV1ExamExamitemidPreviewQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidPreview.ts";
import { examItemPreviewViewModelSchema } from "../examItemPreviewViewModelSchema.ts";

export const getApiV1ExamExamitemidPreviewPathParamsSchema = z.object({
  examItemId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamExamitemidPreviewPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamExamitemidPreview200Schema = z.lazy(
  () => examItemPreviewViewModelSchema,
) as unknown as ToZod<GetApiV1ExamExamitemidPreview200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamExamitemidPreview401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidPreview401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamExamitemidPreview404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidPreview404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamExamitemidPreview500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidPreview500>;

export const getApiV1ExamExamitemidPreviewQueryResponseSchema = z.lazy(
  () => getApiV1ExamExamitemidPreview200Schema,
) as unknown as ToZod<GetApiV1ExamExamitemidPreviewQueryResponse>;
